/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem('app_user');
    return saved ? JSON.parse(saved) : null;
  });

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('app_user');
    localStorage.removeItem('app_user');
  };

  useEffect(() => {
    if (user) {
      api.users.getByEmail(user.email)
        .then(freshUser => {
          if (freshUser?.email) {
            if (JSON.stringify(freshUser) !== JSON.stringify(user)) {
              setUser(freshUser);
              sessionStorage.setItem('app_user', JSON.stringify(freshUser));
            }
          } else if (freshUser === null) {
            logout();
          }
        })
        .catch(err => {
          console.error('Failed to fetch fresh user data', err);
        });
    }
  }, [user]);

  const login = async (email, password) => {
    try {
      const res = await api.auth.login(email.trim(), password);
      if (res && res.success) {
        setUser(res.user);
        sessionStorage.setItem('app_user', JSON.stringify(res.user));
        localStorage.removeItem('app_user');
        return { success: true, user: res.user };
      }
      return { success: false, error: res?.error || 'loginError' };
    } catch (err) {
      return { success: false, error: err.message || 'Server error' };
    }
  };

  const register = async (email, password) => {
    try {
      const res = await api.auth.register(email.trim(), password);
      if (res && res.success) {
        return { success: true, user: res.user };
      }
      return { success: false, error: res?.error || 'Server error' };
    } catch (err) {
      return { success: false, error: err.message || 'Server error' };
    }
  };

  const isAdmin = user?.role === 'admin';
  const isActive = user?.status === 'active';

  return (
    <AuthContext.Provider value={{ user, login, register, logout, isAdmin, isActive }}>
      {children}
    </AuthContext.Provider>
  );
};
